import * as types from '../mutation-types'
import documentsRepository from '../../api/documentsRepository'

const state = {
    documentLocation: []
}

const getters = {
    documentLocation: state => state.documentLocation,
}

const actions = {
    uploadDocument({ commit }, document) {
        return documentsRepository.uploadDocument(document).then((response) => {
            commit(types.SET_DOCUMENT_LOCATION, response.data)
        })
    }
}

const mutations = {
    [types.SET_DOCUMENT_LOCATION](state, payload) {
        state.documentLocation = payload
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
